<div class="content-container" style="height: 890px;">
    <div class="content-area">
      <div class="clr-row">
        <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
          <div class="card">
            <div class="card-block">
              <div style="display: flex;">
                <div style="display: flex; justify-content: space-evenly; width: 50%; align-items: center;">
                  <clr-date-container>
                    <label>От дата</label>
                    <input type="date" clrDate name="from" [(ngModel)]="from">
                  </clr-date-container>
                  <clr-date-container>
                    <label>До дата</label>
                    <input type="date" clrDate name="to" [(ngModel)]="to">
                  </clr-date-container>
                  <clr-input-container>
                    <label>Код</label>
                    <input clrInput name="PartNumber" [(ngModel)]="PartNumber" autocomplete="off" />
                    <clr-control-error *clrIfError="'required'">Грешка</clr-control-error>
                  </clr-input-container>
                </div>
                <div style="display: flex; justify-content: flex-end; width: 50%; align-items: center;">
                  <button class="btn btn-outline" (click)="generate()">Генерирай</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="clr-row">
        <div class="clr-col-lg-12 clr-col-md-12 clr-col-12">
          <div class="card">
            <div class="card-header">
              Продажби <span *ngIf="sales != null"> за {{ theProduct?.Name?.BG}} {{theProduct?.PartNumber}} за период от {{from}} до {{to}} </span>
            </div>
            <div class="card-block card-height">
                <clr-datagrid *ngIf="sales != null" class="datagrid-compact" [clrDgRowSelection]="false">

                    <!-- <clr-dg-action-bar>
                      <a #download class="btn btn-sm btn-secondary" href="" (click)="downloadList()" download="products.csv">Свали
                        списък</a>
                    </clr-dg-action-bar> -->
                  
                    <clr-dg-column [clrDgField]="'date'">Дата</clr-dg-column>
                    <clr-dg-column [clrDgField]="'quantity'">Продажби</clr-dg-column>

                    <clr-dg-row *clrDgItems="let sale of sales" [clrDgItem]="sale">
                      <clr-dg-cell>{{sale.date}}</clr-dg-cell>
                      <clr-dg-cell>{{sale.quantity}}</clr-dg-cell>
                    </clr-dg-row>
                    <clr-dg-footer>общо: {{total}}</clr-dg-footer>
                  </clr-datagrid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>